import React, { Suspense } from 'react';
var LoadedAutocorrection = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/product-search-dialog/extensible/async/autocorrection-component" */'./autocorrection-renderer').then(function (_ref) {
    var LoadedAutocorrection = _ref.LoadedAutocorrection;
    return {
      default: LoadedAutocorrection
    };
  });
});
export var AutocorrectAsyncWrapper = function AutocorrectAsyncWrapper(_ref2) {
  var container = _ref2.container,
    fallback = _ref2.fallback;
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(LoadedAutocorrection, {
    container: container,
    fallback: fallback
  }));
};